import chartMixin from './chartMixin';

export default {
  mixins: [chartMixin],
  props: {
    barPercentage: {
      type: Number,
      default: 1,
    },
    categoryPercentage: {
      type: Number,
      default: 0.7,
    },
    showXAxes: {
      type: Boolean,
      default: true,
    },
    showYAxes: {
      type: Boolean,
      default: true,
    },
    showGridLines: {
      type: Boolean,
      default: false,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    autoSkipX: {
      type: Boolean,
      default: false,
    },
    minXRotation: {
      type: Number,
      default: 0,
    },
    maxXRotation: {
      type: Number,
      default: 360,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    tooltipsEnabled: {
      type: Boolean,
      default: true,
    },
    animationDuration: {
      type: Number,
      default: 1000,
    },
  },
  computed: {
    getChartData() {
      let chartDatasets = [
        {
          backgroundColor: this.data.map((s, i) => this.getColor(s[0], i)),
          data: this.data.map(s => s[1]),
        },
      ];

      // Determine if we're using multiple datasets
      // allows us to send in data as:
      // [
      //   ['SABC', {'revenue': 12233, 'count': 1222}],
      //   ['FirstRand Bank Ltd', {'revenue': 45433, 'count': 4552}]
      // ]
      if (this.data.length && this.data[0][1] instanceof Object) {
        // Get our data split into different sets based on their keys
        const sets = {};
        this.data.forEach(data => {
          Object.keys(data[1]).forEach(key => {
            if (!(key in sets)) {
              sets[key] = [];
            }
            sets[key].push(data[1][key]);
          });
        });

        // Now build the actual chart data
        chartDatasets = Object.keys(sets).map(key => ({
          label: key,
          backgroundColor: this.generateTitleColor(key),
          data: sets[key],
        }));
      }

      const chartData = {
        labels: this.data.map(s => s[0]),
        datasets: chartDatasets,
      };

      return chartData;
    },

    getChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.showLegend,
          position: this.legendPosition,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: this.showGridLines,
              },
              display: this.showXAxes,
              barPercentage: this.barPercentage,
              categoryPercentage: this.categoryPercentage,
              stacked: this.stacked,
              ticks: {
                autoSkip: this.autoSkipX,
                maxRotation: this.maxXRotation,
                minRotation: this.minXRotation,
                beginAtZero: true,
              },
            },
          ],
          yAxes: [
            {
              display: this.showYAxes,
              stacked: this.stacked,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        animation: {
          duration: this.animationDuration,
          onComplete: event => {
            if (this.animationComplete !== undefined) {
              this.animationComplete(event);
            }
          },
        },
        onClick: (event, item) => this.$emit('onClick', [event, item]),
        ...this.options,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/charts/mixins/barChartMixin.js